import ApiService from "@/core/services/ApiService";
import {
  mapCategory,
  mapLesson,
  mapMachine,
  mapPathway,
} from "@/modern/services/dashboardMappers";
import {
  ModernCategory,
  ModernLesson,
  ModernMachine,
  IMachine,
  ModernPathway,
  INextEvent,
} from "@/modern/types/dashboard";

const unwrapData = (response: any) => response?.data?.data ?? response?.data ?? {};

export const dashboardService = {
  async fetchLastMachine(): Promise<IMachine> {
    const response = await ApiService.get("/labs/last");
    return mapMachine(unwrapData(response));
  },

  async fetchFreeWeekMachine(): Promise<IMachine> {
    const response = await ApiService.get("/labs/free-week-machine");
    return mapMachine(unwrapData(response));
  },

  async fetchLastPathway(): Promise<ModernPathway> {
    const response = await ApiService.get("/account/pathways/last");
    return mapPathway(unwrapData(response));
  },

  async fetchLastLesson(): Promise<ModernLesson> {
    const response = await ApiService.get("/academy/lessons/last");
    return mapLesson(unwrapData(response));
  },

  async fetchAllCategories(): Promise<ModernCategory[]> {
    const response = await ApiService.get("/account/tags/categories");
    const data = unwrapData(response);
    return Array.isArray(data) ? data.map(mapCategory) : [];
  },

  async fetchOwnedCategories(categoryIds?: Array<number | string>): Promise<ModernCategory[]> {
    if (!categoryIds || categoryIds.length === 0) {
      const response = await ApiService.get("/account/tags/categories/owned");
      const data = unwrapData(response);
      return Array.isArray(data) ? data.map(mapCategory) : [];
    }

    const params = new URLSearchParams();
    categoryIds.forEach((id) => params.append("categories[]", String(id)));
    const response = await ApiService.get(`/account/tags/categories/owned?${params.toString()}`);
    const data = unwrapData(response);
    return Array.isArray(data) ? data.map(mapCategory) : [];
  },

  async markWelcomeAsRead(): Promise<void> {
    await ApiService.put("/account/welcome-message/mark-as-read", {});
  },

  async fetchNextEvent(): Promise<INextEvent> {
    const response = await ApiService.get("/next-event");
    return unwrapData(response);
  },

  async fetchProgressiveDiscount(): Promise<unknown> {
    const response = await ApiService.get("/user-plan-discount");
    return unwrapData(response);
  }
};
